import { createContext } from 'react';

export const ManageThankYouContext = createContext({ list: [], updateList: () => { } });

export const ManageThankYouConsumer = ManageThankYouContext.Consumer;
